import React, { useState, useEffect } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import { shopifyService } from '../../services/shopify';
import TopMenu from '../../contexts/TopMenu';
import '../../styles/CollectionDetails.css';

function CollectionDetails({ email, onLogout }) {
  const { handle } = useParams();
  const navigate = useNavigate();
  const [collection, setCollection] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState('');

  useEffect(() => {
    const fetchCollection = async () => {
      try {
        const response = await shopifyService.getCollectionDetails(handle);
        setCollection(response.data?.collection);
      } catch (err) {
        setError(err.message);
      } finally {
        setLoading(false);
      }
    };

    fetchCollection();
  }, [handle]);

  if (loading) {
    return (
      <div className="collection-details-loading">
        <div className="loader"></div>
        <p>Loading collection details...</p>
      </div>
    );
  }

  if (error) {
    return (
      <div className="collection-details-error">
        <p>{error}</p>
        <button onClick={() => navigate('/dashboard')}>Back to Dashboard</button>
      </div>
    );
  }

  return (
    <div className="dashboard-root">
      <TopMenu pageTitle={collection?.title || 'Collection Details'} email={email} onLogout={onLogout} />
      <div className="dashboard-container">
        <div className="collection-details">
          <div className="options-grid">
            <div 
              className="option-card"
              onClick={() => navigate(`/c/${handle}/sales`)}
            >
              <div className="option-icon">📊</div>
              <h3>Sales Dashboard</h3>
              <p>View sales analytics and performance metrics</p>
            </div>

            <div 
              className="option-card"
              onClick={() => navigate(`/c/${handle}/products`)}
            >
              <div className="option-icon">📑</div>
              <h3>Catalogue</h3>
              <p>Manage your product catalogue</p>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default CollectionDetails; 